import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useProperty } from '@eti/providers';
import { search as searchPropTypes } from '../../../../widgets/search-form/propTypes';
import SearchResultsGraphqlContainer from '../../containers/SearchResultsGraphqlContainer';
import { useResultPageContext } from './contexts/ResultPageContextProvider';
import ResultSearchDetails from './ResultSearchDetails';

const ResultPageContent = ({
  closeFiltersPanel,
  closeSearchPanel,
  handleSearch,
  handleSearchData,
  handleShowValidWithVoucher,
  handleSort,
  isFiltersPanelOpen,
  isInitialTripSelectionLoading,
  isSearchPanelOpen,
  isSearchLoading,
  isSelectTripLoading,
  isSelfServiceRebooking,
  onShowAncillaryBundleModal,
  rebookingData,
  searchData,
  selectedTripData,
  setIsSearchLoading,
  setShowTripIsNotAvailableModal,
  setShouldRefetch,
  shouldRefetch,
  shouldShowSelectedTrip,
  shouldShowTripIsNotAvailableModal,
  toggleFiltersPanel,
  toggleSearchPanel,
}) => {
  const hasSelectedTrip = shouldShowSelectedTrip && Boolean(selectedTripData);
  const [isSavedTripDrawerOpen, setIsSavedTripDrawerOpen] = useState(false);
  const { p } = useProperty();
  const isSkeletonEnabled = p('Result.Skeleton.Enabled');
  const { setTripsDetails, setSelectedTrip, savedTrips, removeSavedTrip, addSavedTrip, addTrip } =
    useResultPageContext();

  if (savedTrips.length === 0 && isSavedTripDrawerOpen) {
    setIsSavedTripDrawerOpen(false);
  }
  useEffect(() => {
    if (searchData) {
      const { flights, sponsoredTrips } = searchData;
      const flightDetails = selectedTripData
        ? [...flights, selectedTripData, ...sponsoredTrips]
        : [...flights, ...sponsoredTrips];
      setTripsDetails(flightDetails);
    }
    setSelectedTrip(null);
    if (selectedTripData) {
      setSelectedTrip(selectedTripData);
    }
  }, [searchData, setSelectedTrip, setTripsDetails, selectedTripData]);

  return (
    <>
      {((!isSearchLoading && !isSkeletonEnabled) || isSkeletonEnabled) && (
        <ResultSearchDetails
          closeSearchPanel={closeSearchPanel}
          isSearchPanelOpen={isSearchPanelOpen}
          onSearch={handleSearch}
          rebookingData={rebookingData}
          search={searchData}
          shouldShowSkeleton={!searchData || isInitialTripSelectionLoading}
          toggleSearchPanel={toggleSearchPanel}
        />
      )}
      <SearchResultsGraphqlContainer
        addSavedTrip={addSavedTrip}
        addTrip={addTrip}
        closeFiltersPanel={closeFiltersPanel}
        handleSearch={handleSearch}
        hasSelectedTrip={hasSelectedTrip}
        isFiltersPanelOpen={isFiltersPanelOpen}
        isInitialTripSelectionLoading={isInitialTripSelectionLoading}
        isSelectTripLoading={isSelectTripLoading}
        isSelfServiceRebooking={isSelfServiceRebooking}
        onSearchComplete={handleSearchData}
        onShowAncillaryBundleModal={onShowAncillaryBundleModal}
        onShowValidWithVoucher={handleShowValidWithVoucher}
        onSort={handleSort}
        removeSavedTrip={removeSavedTrip}
        savedTrips={savedTrips}
        searchData={searchData}
        setIsSearchLoading={setIsSearchLoading}
        setShouldRefetch={setShouldRefetch}
        setShowTripIsNotAvailableModal={setShowTripIsNotAvailableModal}
        shouldRefetch={shouldRefetch}
        shouldShowTripIsNotAvailableModal={shouldShowTripIsNotAvailableModal}
        toggleFiltersPanel={toggleFiltersPanel}
        toggleSearchPanel={toggleSearchPanel}
      />
    </>
  );
};

ResultPageContent.propTypes = {
  closeFiltersPanel: PropTypes.func,
  closeSearchPanel: PropTypes.func,
  handleSearch: PropTypes.func,
  handleSearchData: PropTypes.func,
  handleShowValidWithVoucher: PropTypes.func,
  handleSort: PropTypes.func,
  isFiltersPanelOpen: PropTypes.bool,
  isInitialTripSelectionLoading: PropTypes.bool,
  isSearchLoading: PropTypes.bool,
  isSearchPanelOpen: PropTypes.bool,
  isSelectTripLoading: PropTypes.bool,
  isSelfServiceRebooking: PropTypes.bool,
  onShowAncillaryBundleModal: PropTypes.func,
  rebookingData: PropTypes.shape({
    formConstraints: PropTypes.shape({
      passengers: PropTypes.shape({
        isDisabled: PropTypes.bool,
        maxNumberOfTravelers: PropTypes.number,
      }),
    }),
    initialValues: PropTypes.shape({
      passengers: PropTypes.shape({
        adults: PropTypes.number,
        children: PropTypes.number,
        infants: PropTypes.number,
      }),
    }),
  }),
  searchData: searchPropTypes,
  selectedTripData: PropTypes.objectOf(PropTypes.any),
  setIsSearchLoading: PropTypes.func,
  setShouldRefetch: PropTypes.func,
  setShowTripIsNotAvailableModal: PropTypes.func,
  shouldRefetch: PropTypes.bool,
  shouldShowSelectedTrip: PropTypes.bool,
  shouldShowTripIsNotAvailableModal: PropTypes.bool,
  toggleFiltersPanel: PropTypes.func,
  toggleSearchPanel: PropTypes.func,
};

export default ResultPageContent;
